import { UI_ContentSection } from 'ui/components/4-habitats/ContentSection/ContentSection';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';

export const ContentSectionFeature: React.FC<Content.ContentSection> = ({ content, settings }) => {
	const { content: contentModules, title } = content?.properties ?? {};
	const { centered, width } = settings?.properties ?? {};

	return (
		<UI_ContentSection centered={centered} width={width} title={title}>
			{contentModules.map((contentModule, index) => {
				if (
					contentModule?.settings &&
					'desktopWidth' in contentModule?.settings?.properties &&
					'mobileWidth' in contentModule?.settings?.properties
				) {
					const { desktopWidth, mobileWidth } = contentModule?.settings?.properties ?? {};

					return (
						<UI_GridCell key={index} desktopWidth={desktopWidth} mobileWidth={mobileWidth}>
							<ModuleFeature contentModule={contentModule} />
						</UI_GridCell>
					);
				}

				return <ModuleFeature contentModule={contentModule} key={index} />;
			})}
		</UI_ContentSection>
	);
};
